import Controller from '@ember/controller';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { task } from 'ember-concurrency';
import type FlashMessagesService from 'garaje/services/flash-messages';
import type SigmaUrlService from 'garaje/services/sigma-url';
import type StateService from 'garaje/services/state';
import { Workbook } from 'garaje/utils/sigma-workbooks';

export default class GlobalAnalyticsRoomsIndexController extends Controller {
  @service declare state: StateService;
  @service declare flashMessages: FlashMessagesService;
  @service declare sigmaUrl: SigmaUrlService;

  @tracked isError = false;

  fetchSigmaUrlTask = task({ drop: true }, async () => {
    const companyId = this.state?.currentCompany?.id;
    try {
      const result = await this.sigmaUrl.getGlobalSigmaUrl(companyId, Workbook.GLOBAL_ROOMS);
      return result;
    } catch (e) {
      this.flashMessages.showAndHideFlash('error', 'Error loading dashboard');
      this.isError = true;
      // eslint-disable-next-line no-console
      console.error(e);
      return;
    }
  });

  get sigmaIframeUrl(): string | null | undefined {
    return this.fetchSigmaUrlTask.last?.value;
  }
}
